import React from "react";
import ReactDOMServer from "react-dom/server";
import IntraverseLogo from "../../demo/IntraverseLogo";

function AccountStatementPDFHeaderStatic(data) {
  const detailsRows = [
    { label: "Email", value: data?.account?.email },
    // { label: "Cust ID", value: data?.account?.customerId },
    { label: "Account NO", value: data?.account?.accountNumber },
    { label: "A/C Open Date", value: data?.account?.accountOpenDate },
    { label: "Account Status", value: data?.account?.accountStatus },
    { label: "Total Bookings Made", value: data?.account?.totalBookingsMade },
    { label: "Commission Earned", value: data?.account?.commissionEarned },
    { label: "Markup Earned", value: data?.account?.markupEarned },
    { label: "Service Fees Paid", value: data?.account?.serviceFeesPaid },
    { label: "Refunds", value: data?.account?.refunds },
    { label: "Net Earnings", value: data?.account?.netEarnings },
    { label: "Wallet Balance", value: data?.account?.walletBalance },
  ];

  const staticContent = (
    <div className="w-full flex">
      <table className="w-full border-collapse border-none">
        <tbody>
          <tr>
            <td className="align-top w-1/2 mr-8">
              <div className="w-full flex flex-col">
                <div>
                  <IntraverseLogo />
                </div>
                <span className="font-medium text-xl">
                  Innovating tavel sales for Africa
                </span>
                <div className="mt-4 w-full flex flex-col border-2 border-black p-4 bg-blue-300">
                  <span className="font-semibold">{data?.account?.name}</span>
                  <span className="font-light">{data?.account?.street}</span>
                  <span className="font-light">{data?.account?.city}</span>
                  <span className="font-light">{data?.account?.state}</span>
                </div>
              </div>
            </td>

            <td className="align-top w-1/2">
              <div className="w-full flex-1 flex-col ml-8 pt-10">
                <table className="w-full border-collapse text-sm leading-tight">
                  <tbody>
                    {detailsRows.map((detail, i) => (
                      <tr key={i} className="align-top">
                        <td className="p-0 w-1/3">
                          <small className="font-semibold leading-tight">
                            {detail.label}
                          </small>
                        </td>
                        <td className="px-1 p-0">
                          <small className="font-semibold leading-tight">
                            :
                          </small>
                        </td>
                        <td className="p-0">
                          <small className="font-semibold leading-tight">
                            {detail.value}
                          </small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              <div className="py-4">
                <span className="font-semibold">
                  Subscription: {data?.account?.subscriptionStatus}
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span className="font-semibold my-4">
                From: {data?.meta?.from}
              </span>
            </td>
            <td>
              <span className="font-semibold my-4">To: {data?.meta?.to}</span>
            </td>
            <td className="text-right w-1/3">
              <span className="font-semibold my-4 text-end whitespace-nowrap">
                Statement of account
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(staticContent);
}

export default AccountStatementPDFHeaderStatic;
